import dayjs from "dayjs";

const getDataByDate = ({
    oldData = "",
    newData = "",
    newStartDate = ""
} = {}) => {
    const currentDate = dayjs();
    return currentDate >= dayjs(newStartDate) ? newData : oldData;
};

export default getDataByDate;
